export const PDF_HEADER = {
    pt: [
        {
            datakey: 'date',
            title: 'Data',
        },
        {
            datakey: 'vigilant',
            title: 'Vigilante',
        },
        {
            datakey: 'type',
            title: 'Tipo',
        },
        {
            datakey: 'notes',
            title: 'Notas',
        },
    ],
    en: [
        {
            datakey: 'date',
            title: 'Date',
        },
        {
            datakey: 'vigilant',
            title: 'Vigilant',
        },
        {
            datakey: 'type',
            title: 'Type',
        },
        {
            datakey: 'notes',
            title: 'Notes',
        },
    ],
}
